import Swiper from "swiper";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export default function swiperPropertyGalleryGrid() {
    const swiper = new Swiper(".property-gallery-grid-swiper", {
        modules: [Pagination],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
}
